import React from 'react';
import {Checkbox, IconButton, TableCell} from '@mui/material';
import {
  AudioIcon,
  DocumentIcon,
  FavoriteIcon,
  FileIcon,
  ImageIcon,
  JournalPostIcon,
  LinkIcon,
  OpenIcon,
  PostIcon,
  SpacecastIcon,
  SurveyAttemptIcon,
  TagIcon,
  UploadIcon,
  VideoIcon,
} from '../../../../../helpers/Icons'
import UploadThumbnail from "../item-viewer/UploadThumbnail";
import {formatByteSize, formatLocation} from "../../../../../helpers/FormatUtils";
import CheckIcon from "@mui/icons-material/Check";
import ItemTypeIcon from "../../../../../helpers/ItemTypeIcon";
import ColorGrid from "../../surveys/common/results/ColorGrid";

export function selectCell(key, item, isSelected, openDataView, classes, history, column){
  return (
    <TableCell id={`${key}Cell`} key={key} className={classes.checkbox}>
      <Checkbox id="itemSelect" checked={isSelected} />
    </TableCell>);
}

export function iconCell(key, item, isSelected, openDataView, classes, history, column){
  return (
    <TableCell id={`${key}Cell`} key={key}
      onClick={openDataView}
      className={classes.openLinkIcon}
    >
      <div className={classes.rowIcon}>
        {item.item_data_type === "Upload" ? <UploadThumbnail item={item} size="sm" />
          : item.item_data_type === "SurveyAttempt" ? <ColorGrid surveyAttempt={item.item_data} noGap />
          : null }
      </div>
    </TableCell>);
}

export function nameCell(key, item, isSelected, openDataView, classes, history, column){
  return (
    <TableCell id={`${key}Cell`} key={key}
               onClick={openDataView}
               className={classes.openLink}
    >
      {item.name}
      <OpenIcon/>
    </TableCell>);
}

export function nameCellLg(key, item, isSelected, openDataView, classes, history, column){
  return (
    <TableCell id={`${key}Cell`} key={key}
               onClick={openDataView}
               className={classes.openLink}
               style={{
                 maxWidth: 'calc(max(100%,40dvw) )',
                 minWidth: '8em',
                 width:'30dvw',
               }}
    >
      {item.name}
      <OpenIcon/>
    </TableCell>);
}

export function descriptionCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.descriptionCell} style={{padding:'0px 8px'}}>
      <div className={classes.descriptionText}>
        {item.description}
      </div>
    </TableCell>);
}

const iconProps = {style: {color: '#005985', padding:'3px 0'}};
const itemTypeIcons = {
  'Upload': <UploadIcon {...iconProps} />,
  'Link': <LinkIcon {...iconProps} />,
  'Favorite': <FavoriteIcon {...iconProps} />,
  'JournalPost': <JournalPostIcon {...iconProps} />,
  'SurveyAttempt': <SurveyAttemptIcon {...iconProps} />,
}
export function itemDataTypeCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.typeCell}> {getTypeIcon(item.item_data_type, item.type_variant)} </TableCell>);
}

const uploadTypeIcons = {
  'audio': <AudioIcon {...iconProps} />,
  'image': <ImageIcon {...iconProps} />,
  'video': <VideoIcon {...iconProps} />,
  'document': <DocumentIcon {...iconProps} />,
  'post': <PostIcon {...iconProps} />,
  'file': <FileIcon {...iconProps} />,
}

export function typeVariantCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key}> {uploadTypeIcons[item.type_variant]} </TableCell>);
}
export function typeVariantNameCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} style={{textTransform: 'capitalize'}}> {item.type_variant} </TableCell>);
}
export function statusNameCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} style={{textTransform: 'capitalize'}}> {item.status} </TableCell>);
}
const statusIcons = (status, openDataView, classes, history, column) => {
  if(status === 'pending'){
    return (
      // todo: icon small
      <IconButton id="statusCell" size="small" className={classes.pendingButton} onClick={openDataView}>
        <TagIcon style={{color: '#ffb506'}} />
      </IconButton>);
  }else{
    return null; //<div className={classes.pendingPlaceholder}  />;
  }
}

function getTypeIcon(type, variant){
    return variant ? uploadTypeIcons[variant] : itemTypeIcons[type];
}

export function statusCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} className={classes.typeCell} >
    <div className={classes.icons}>
      <ItemTypeIcon id="typeCell" item={item} {...iconProps} />
      {statusIcons(item.status, openDataView, classes, history, column)}
    </div>
  </TableCell>);
}

export function typeCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} className={classes.typeCellSm} >
    <div className={classes.icons}>
      <ItemTypeIcon id="typeCell" item={item} {...iconProps} />
    </div>
  </TableCell>);
}

export function dateCell(key, item, isSelected, openDataView, classes, history, column){
  return formatDate(key, item.date, classes);
}
export function locationCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} className={classes.locationCell} > {formatLocation("locationCell", item.location, classes)} </TableCell>);
}
export function keywordsCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} className={classes.tagListCell} > {formatArray(`${key}Cell`, item.keywords, k => k.text, k => k.id, classes, column)} </TableCell>);
}
export function peopleCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} className={classes.tagListCell} > {formatArray(`${key}Cell`, item.people, p => p.name, p => p.id, classes, column)} </TableCell>);
}
export function emotionCell(key, item, isSelected, openDataView, classes, history, column){
  return formatItem(key, item, i => i.emotion, i => i.emotion, classes, column);
}
export function bemeCell(key, item, isSelected, openDataView, classes, history, column){
  return formatItem(key, item, i => i.beme, i => i.beme, classes, column);
}
export function createdCell(key, item, isSelected, openDataView, classes, history, column){
  return formatDateTime(key, item.created_at, classes);
}
export function updatedCell(key, item, isSelected, openDataView, classes, history, column){
  return formatDateTime(key, item.updated_at, classes);
}
export function sharingCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.tagCell} > {!!item.share_hash ? <CheckIcon /> : null} </TableCell>);
}
export function spacecastCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.tagCell} > {!!item.spacecast_upload ? <SpacecastIcon /> : null} </TableCell>);
}
function smallCell(key, item, content, column, className, actionClass){
  const el = !column.action ? content :  <span className={actionClass}
    onClick={(e) => {
      if(e){
        e.preventDefault();
        e.stopPropagation();
      }
      if(typeof(column.action) === "function"){
        column.action(item);
      }
    }}>{content}</span>;
  return (<TableCell id={`${key}Cell`} key={key} className={className} > {el} </TableCell>);
}
export function fieldCell(contentFunc){
  return (key, item, isSelected, openDataView, classes, history, column) => smallCell(key, item, contentFunc(item), column, classes.tagCell, classes.tagCellAction)
}
export function fieldCellSm(contentFunc){
  return (key, item, isSelected, openDataView, classes, history, column) => smallCell(key, item, contentFunc(item), column, classes.tagCellSm, classes.tagCellAction)
}
export function fieldCellDateTime(contentFunc){
  return (key, item, isSelected, openDataView, classes, history, column) => formatDateTime(key, contentFunc(item), classes)
}
export function sizeCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.tagCell} > {formatByteSize(item.item_data.size, classes)} </TableCell>);
}


export function folderNameCell(key, item, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`folderCell`} key={key} className={classes.folderCell} onClick={(e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    history.push(`/explore/folder/${item.folder_id}`);
  }} >
    {item.folder_name}
    <OpenIcon/>
  </TableCell>);
}

export function folderNameCellLg(key, item, isSelected, openDataView, classes, history, column){
  return (
    <TableCell id={`folderCell`} key={key}
      className={classes.folderCell}
      style={{
        maxWidth: 'calc(max(100%,40dvw) )',
        minWidth: '8em',
        width:'15dvw',
      }}

      onClick={(e) => {
        if(e){
          e.preventDefault();
          e.stopPropagation();
        }
        history.push(`/explore/folder/${item.folder_id}`);
      }}
    >
      {item.folder_name}
      <OpenIcon/>
    </TableCell>);
}

export function sourceCell(key, item, isSelected, openDataView, classes, history, column){
  return <TableCell id={`${key}Cell`} key={key} className={classes.tagCell} style={{textTransform: 'capitalize'}}> {item.item_data.source} </TableCell>;
}
export function extensionCell(key, item, isSelected, openDataView, classes, history, column){
  return <TableCell id={`${key}Cell`} key={key} className={classes.tagCellSm}  style={{textTransform: 'uppercase'}}> {item.item_data.extension || ''} </TableCell>;
}

export function formatItemDataType(itemDataType){
  return itemDataType === 'JournalPost' ? 'Journal'
    : itemDataType === 'SurveyAttempt' ? 'Profile Assessment'
    : itemDataType;
}

function formatDate(key, dateString, classes){
  return (<TableCell id={`${key}Cell`} key={key} style={{width:'5em', whiteSpace:'nowrap'}} >
    {dateString ? (typeof(dateString) === "string" ? new Date(dateString.replace(/-/g, '/')).toLocaleDateString() : new Date(dateString).toLocaleDateString()) : ''}
    </TableCell>);
}

function formatDateTime(key, dateString, classes){
  return (<TableCell id={`${key}Cell`} key={key} style={{width:'5em', whiteSpace:'nowrap'}} >
      <div style={{display:'inline-block', textAlign:'right'}}>
        <div style={{whiteSpace:'nowrap'}} >{dateString ? new Date(dateString).toLocaleDateString() : ''}</div>
        <div className={classes.cellSubtext} >{dateString ? new Date(dateString).toLocaleTimeString() : ''}</div>
      </div>
    </TableCell>);
}

function formatArray(id, arr, textMapping, idMapping, classes, column){
  const items = (arr || []).filter(item => !!item && typeof(item) !== "string").map(item => ({text: textMapping(item), id: idMapping ? idMapping(item) : null}));
  return (<div className={classes.tagListInner}>
      {items.length > 0 ?
        <div className={classes.tagListCount}>
          {items.length}
        </div>
      : null}
      <span id={id}>
        {column.action ? items.map((item) =>
          <div key={item.id} className={classes.tagListActionItem} onClick={(e) => {
              if(e){
                e.preventDefault();
                e.stopPropagation();
              }
              column.action(item.id);
            }}>
            {item.text}
          </div>
        )
        : items.map((item, index) =>
          <div key={item.id} className={classes.tagListItem}>
            {item.text}
          </div>
        )}
      </span>
    </div>);
}

function formatItem(key, item, textMapping, idMapping, classes, column){
  const text = textMapping(item);
  const id = idMapping ? idMapping(item) : null;

  return column.action && !!id ?
    <TableCell className={classes.tagCell} id={`${key}Cell`} key={key}>
      <span className={classes.tagCellAction} onClick={(e) => {
        if(e){
          e.preventDefault();
          e.stopPropagation();
        }
        column.action(id);
      }}>
        {text}
      </span>
    </TableCell>
    : <TableCell id={`${key}Cell`} key={key} className={classes.tagCell}>
        {text}
      </TableCell>;
}
